import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AnswersService } from '@services';
import { QuickAnswers, QuickAnswersGroups } from '@interfaces';

@Component({
  selector: 'unicon-quick-answers-dialog',
  templateUrl: './quick-answers-dialog.component.html',
  styleUrl: './quick-answers-dialog.component.scss',
})
export class QuickAnswersDialogComponent {
  protected editQuickAnswer: boolean = false;
  protected addQuickAnswer: boolean = false;
  public isLoading: boolean = false;
  public isLoadingQuickAnswers: boolean = false;
  public isLoadingAnswersTypes: boolean = false;
  public form!: FormGroup;
  public quickAnswersList: QuickAnswersGroups[] = [];
  protected navAnswersItems: QuickAnswers[] = [];
  //protected messageItems: QuickAnswersGroups[] = [];
  protected selectedAnswerType = {} as QuickAnswers;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    public dialogRef: MatDialogRef<QuickAnswersDialogComponent>,
    private formBuilder: FormBuilder,
    private quickAnswersService: AnswersService,
  ) {
    this.setForm();
  }

  ngOnInit(): void {
    this.getQuickAnswersGroups();
  }

  private getQuickAnswersGroups(): void {
    this.isLoadingAnswersTypes = true;
    this.quickAnswersService.getQuickAnswers().subscribe({
      next: (quickAnswerType: QuickAnswers[]) => {
        const answers = quickAnswerType ? quickAnswerType : [];
        this.isLoadingAnswersTypes = false;
        this.navAnswersItems = answers.map(item => ({
          ...item,
          active: false,
        }));
        this.setActiveAAnswerType(this.navAnswersItems[0]);
        this.getQuickAnswersByGroup(this.navAnswersItems[0]);
      },
      error: () => {
        this.isLoadingAnswersTypes = false;
      },
    });
  }

  private getQuickAnswersByGroup(type: QuickAnswers): void {
    this.isLoadingQuickAnswers = true;
    this.quickAnswersService.getQuickAnswerById(type.id).subscribe({
      next: (quickAnswers: QuickAnswersGroups[]) => {
        const answers = quickAnswers ? quickAnswers : [];
        this.quickAnswersList = answers.map(item => ({
          ...item,
          isActivated: false,
        }));
        this.isLoadingQuickAnswers = false;
      },
      error: () => {
        this.isLoadingQuickAnswers = false;
      },
    });
  }

  protected setActiveAAnswerType(type: QuickAnswers) {
    if (type) {
      this.selectedAnswerType = type;
      this.navAnswersItems = this.navAnswersItems.map((item: QuickAnswers) => {
        if (item.name === type.name) {
          return { ...item, active: true };
        }
        return { ...item, active: false };
      });
      this.getQuickAnswersByGroup(type);
    }
  }

  protected closeModal(): void {
    this.dialogRef.close();
  }

  protected editQuickAnswers(answer: QuickAnswersGroups): void {
    const newQuickAnswersList = this.quickAnswersList.map(item => {
      if (item.id === answer.id) {
        return { ...item, isActivated: true };
      } else {
        return { ...item };
      }
    });
    this.quickAnswersList = newQuickAnswersList;

    this.form = this.formBuilder.group({
      type: new FormControl(answer.type),
      message: new FormControl(answer.message),
    });
  }

  protected deleteQuickAnswers(answer: QuickAnswersGroups): void {
    this.quickAnswersService
      .deleteQuickAnswers(answer.groupId, answer.id)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.getQuickAnswersByGroup(this.selectedAnswerType);
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  protected addQuickAnswers(): void {
    this.form = this.formBuilder.group({
      type: new FormControl(''),
      message: new FormControl(''),
    });
    this.addQuickAnswer = true;
  }

  private setForm(): void {
    this.form = this.formBuilder.group({
      type: new FormControl(''),
      message: new FormControl(''),
    });
  }

  protected onSubmit(): void {
    this.isLoading = true;
    const quickAnswer = this.form.value;
    this.quickAnswersService
      .createQuickAnswers(quickAnswer, this.selectedAnswerType.id)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.addQuickAnswer = false;
          this.getQuickAnswersByGroup(this.selectedAnswerType);
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  protected onEditAnswer(answer: QuickAnswersGroups): void {
    this.isLoading = true;
    const quickAnswerRequest = {
      ...this.form.value,
    };

    const quickAnswerType = {
      id: answer.id,
      group: answer.groupId,
    };

    this.quickAnswersService
      .updateQuickAnswers(quickAnswerRequest, quickAnswerType)
      .subscribe({
        next: () => {
          this.isLoading = false;
          const newQuickAnswersList = this.quickAnswersList.map(item => {
            if (item.id === answer.id) {
              return {
                ...item,
                type: this.form.value.type,
                message: this.form.value.message,
                isActivated: false,
              };
            } else {
              return { ...item };
            }
          });
          this.quickAnswersList = newQuickAnswersList;
          this.getQuickAnswersByGroup(this.selectedAnswerType);
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }
}
